// extracted by mini-css-extract-plugin
export default {"btn":"SearchResultRow_btn__ZCRm+","table-number-cell":"SearchResultRow_table-number-cell__HgtZq","tr":"SearchResultRow_tr__52g6D"};